import { useTranslation } from 'react-i18next';

import { Button } from '@/components/atoms/Buttons';
import InfoTip from '@/components/atoms/InfoTip';
import ContentBlock from '@/components/molecules/ContentBlock';

import { PositionValue } from '../PositionValue/PositionValue';

import styles from './ServiceCard.module.scss';

interface ServiceCardProps {
    distance: number | null;
    depth: number | null;
    canMove: boolean;
    moveDisabledReason: string;
    onMove: () => void;
}

export function ServiceCard(props: ServiceCardProps) {
    const { distance, depth, canMove, moveDisabledReason, onMove } = props;
    const { t } = useTranslation();
    const setAutomatically = t('winchControl.card.setAutomatically');

    return (
        <ContentBlock
            shrink
            title={t('winchControl.card.service')}
            headerActions={
                <InfoTip
                    label={t('winchControl.card.autoCalculatedHelp')}
                    content={t('winchControl.card.autoCalculatedTooltip')}
                />
            }>
            <div className={styles.values}>
                <PositionValue
                    label={t('winchControl.card.distance')}
                    value={distance}
                    unit={t('winchControl.position.meters')}
                    caption={setAutomatically}
                />
                <PositionValue
                    label={t('winchControl.card.depth')}
                    value={depth}
                    unit={t('winchControl.position.meters')}
                    caption={setAutomatically}
                />
            </div>
            <div className={styles.actions}>
                <Button
                    variant="primary"
                    onClick={onMove}
                    disabled={!canMove}
                    trackingId="winch_service_move"
                    tooltip={!canMove ? moveDisabledReason : t('winchControl.button.moveTooltip')}
                    tooltipPlacement="left">
                    {t('winchControl.button.moveBioscope')}
                </Button>
            </div>
        </ContentBlock>
    );
}
